import { __rest } from '../../_virtual/_tslib.js';
import { CardsWrapper } from '@lsg/shared';
import { createElement } from 'react';
import { CardsCheckboxesItem } from '../CardsCheckboxesItem/CardsCheckboxesItem.js';

var CardsCheckboxes = function CardsCheckboxes(_a) {
  var _a$itemsPerRow = _a.itemsPerRow,
    itemsPerRow = _a$itemsPerRow === void 0 ? 4 : _a$itemsPerRow,
    props = __rest(_a, ["itemsPerRow"]);
  return /*#__PURE__*/createElement(CardsWrapper, Object.assign({}, Object.assign({
    itemsPerRow: itemsPerRow
  }, props)));
};
CardsCheckboxes.displayName = "Cards.Checkboxes";
CardsCheckboxes.Item = CardsCheckboxesItem;

export { CardsCheckboxes };
